import { mutatorAction } from "satcheljs";
import { ProgressiveStore } from "../";

export default mutatorAction('RESET_PROGRESSIVE_STORE', function resetStore() {
    ProgressiveStore().shifts.clear();
    ProgressiveStore().openShifts.clear();
    ProgressiveStore().notes.clear();
});
